import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, ScanIdSchema } from "../primitives/ids.js";
import { ExternalEvidenceConfidenceV1Schema, ExternalEvidenceProvenanceV1Schema, } from "./external-site-proof.js";
export const ImportDraftIdSchema = z
    .string()
    .regex(/^imdrft_[a-zA-Z0-9_-]+$/)
    .brand();
export const ImportSuggestionFieldKindSchema = z.enum([
    "businessName",
    "phone",
    "email",
    "address",
    "service",
    "serviceArea",
    "cta",
    "heading",
    "pageTitle",
    "metaDescription",
    "schemaBlock",
    "trustClaim",
    "contactPath",
    "importantPage",
]);
export const ImportClaimRiskV1Schema = z.enum(["LOW", "MEDIUM", "HIGH"]);
/** Single imported field suggestion — never active BusinessGraph truth. */
export const ImportSuggestionV1Schema = z
    .object({
    suggestionId: z.string().min(1),
    fieldKind: ImportSuggestionFieldKindSchema,
    value: z.string().min(1).max(4096),
    sourceRef: z.string().min(1),
    provenance: ExternalEvidenceProvenanceV1Schema,
    confidence: ExternalEvidenceConfidenceV1Schema,
    unresolvedReason: z.string().min(1).optional(),
    claimRisk: ImportClaimRiskV1Schema.optional(),
})
    .strict();
export const ImportDraftStatusSchema = z.enum(["PENDING", "PROCESSING", "COMPLETE", "FAILED"]);
/** Worker-produced import draft — suggestions only. */
export const ImportDraftV1Schema = z
    .object({
    schemaId: z.literal("importDraft.v1"),
    importDraftId: ImportDraftIdSchema,
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema.optional(),
    snapshotId: z.string().min(1).optional(),
    scanId: ScanIdSchema.optional(),
    sourceUrl: z.string().url(),
    status: ImportDraftStatusSchema,
    suggestions: z.array(ImportSuggestionV1Schema),
    extractedAt: z.string().datetime().optional(),
    failureReason: z.string().min(1).optional(),
})
    .strict();
export const ImportDraftEnqueueRequestV1Schema = z
    .object({
    schemaId: z.literal("importDraft.enqueueRequest.v1"),
    snapshotId: z.string().min(1),
})
    .strict();
export const ImportDraftEnqueueAcceptedV1Schema = z
    .object({
    schemaId: z.literal("importDraft.enqueueAccepted.v1"),
    importDraftId: ImportDraftIdSchema,
    status: z.literal("PENDING"),
})
    .strict();
export const ImportDraftViewV1Schema = z
    .object({
    schemaId: z.literal("importDraft.view.v1"),
    importDraftId: ImportDraftIdSchema,
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema.optional(),
    snapshotId: z.string().min(1).optional(),
    sourceUrl: z.string().url(),
    status: ImportDraftStatusSchema,
    suggestions: z.array(ImportSuggestionV1Schema),
    extractedAt: z.string().datetime().optional(),
    failureReason: z.string().min(1).optional(),
})
    .strict();
//# sourceMappingURL=import-draft.js.map